"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumSheet = void 0;
const CoordinateConverter_1 = require("../parse/CoordinateConverter");
const fonts_1 = require("../../../../Fonts/fonts");
class AltiumSheet {
    static { this.FontSizeConversionRatio = 5.4; }
    static { this.DefaultSnapGridSizeMils = 100; }
    constructor(record) {
        this.record = record;
        this._fonts = AltiumSheet.parseFonts(record);
    }
    getSnapGridSizeMils() {
        const snapGridSizeMils = CoordinateConverter_1.CoordinateConverter.parseFractionalCoordinate(this.record.properties, 'snapgridsize');
        return snapGridSizeMils > 0 ? snapGridSizeMils : AltiumSheet.DefaultSnapGridSizeMils;
    }
    isSnapGridEnabled() {
        const snapGridOn = this.record.properties['snapgridon']?.value;
        return snapGridOn === undefined ? true : CoordinateConverter_1.CoordinateConverter.altiumBool(snapGridOn);
    }
    getFonts() {
        return this._fonts;
    }
    getFont(fontId) {
        const fontIdNum = typeof fontId === 'string' ? parseInt(fontId, 10) : fontId;
        if (fontIdNum === 0) {
            return this.getDefaultFont();
        }
        const font = this._fonts.get(fontIdNum);
        if (font === undefined) {
            throw new Error(`Font not found with ID: ${fontId}`);
        }
        return font;
    }
    getDefaultFont() {
        const font1 = this._fonts.get(1);
        if (font1) {
            return font1;
        }
        return {
            fontName: fonts_1.Font.Newstroke,
            size: 1.47,
            areaColor: { r: 0, g: 0, b: 0 },
            textOpts: {
                size: 1.47,
            },
        };
    }
    static parseFonts(record) {
        const fonts = new Map();
        const { fontIdCount, properties } = record;
        for (let i = 1; i <= fontIdCount; i++) {
            const fontName = properties[`fontname${i}`]?.value ?? '';
            const size = CoordinateConverter_1.CoordinateConverter.milsToMm(parseInt(properties[`size${i}`]?.value ?? '10', 10)) *
                AltiumSheet.FontSizeConversionRatio;
            const rotation = properties[`rotation${i}`]?.value ? parseInt(properties[`rotation${i}`].value, 10) : undefined;
            const italic = properties[`italic${i}`]?.value ? CoordinateConverter_1.CoordinateConverter.altiumBool(properties[`italic${i}`].value) : undefined;
            const bold = properties[`bold${i}`]?.value ? CoordinateConverter_1.CoordinateConverter.altiumBool(properties[`bold${i}`].value) : undefined;
            const underline = properties[`underline${i}`]?.value ?
                CoordinateConverter_1.CoordinateConverter.altiumBool(properties[`underline${i}`].value)
                : undefined;
            const areaColor = CoordinateConverter_1.CoordinateConverter.convertColor(parseInt(properties[`areacolor${i}`]?.value ?? '0', 10));
            const textAttrs = [];
            if (italic) {
                textAttrs.push('italic');
            }
            if (bold) {
                textAttrs.push('bold');
            }
            fonts.set(i, {
                fontName,
                size,
                rotation,
                italic,
                bold,
                underline,
                areaColor,
                textOpts: {
                    attr: textAttrs.length > 0 ? textAttrs : undefined,
                    size,
                },
            });
        }
        return fonts;
    }
}
exports.AltiumSheet = AltiumSheet;
//# sourceMappingURL=AltiumSheet.js.map